/*
 * Quick add on product cards (snippets/card-product.liquid, show_quick_add). The "+" on a card whose
 * only choices are Size and Print Type opens the bag's size sheet (assets/runit-bag-v2.js): Print
 * finish starts on Non-Reflective, no size is chosen until the shopper taps one, and that tap adds
 * the exact variant and opens the bag. Without the bag script the "+" goes to the product page.
 */
(function () {
  'use strict';

  var FINISH = 'Print Type';
  var DEFAULT_FINISH = 'Non-Reflective';

  // product .js prices are in the shopper's currency; whole amounts drop the pence ("+£10")
  function money(c, whole) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var d = whole && c % 100 === 0 ? 0 : 2;
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur, minimumFractionDigits: d, maximumFractionDigits: d }).format(c / 100);
  }
  function uniq(list) { return list.filter(function (v, i) { return list.indexOf(v) === i; }); }
  function minPrice(vs) { return Math.min.apply(null, vs.map(function (v) { return v.price; })); }

  function open(p, btn, bag) {
    var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var si = names.indexOf('Size');
    var fi = names.indexOf(FINISH);
    var sizes = uniq(p.variants.map(function (v) { return v.options[si]; }));
    var finishes = fi < 0 ? [] : uniq(p.variants.map(function (v) { return v.options[fi]; }));
    var finish = finishes.indexOf(DEFAULT_FINISH) >= 0 ? DEFAULT_FINISH : finishes[0];

    function ofFinish(f) { return p.variants.filter(function (v) { return fi < 0 || v.options[fi] === f; }); }
    function variant(size) { return ofFinish(finish).filter(function (v) { return v.options[si] === size; })[0]; }
    function priceHtml() {
      var vs = ofFinish(finish);
      var live = vs.filter(function (v) { return v.available; });
      var lo = minPrice(live.length ? live : vs);
      return (vs.some(function (v) { return v.price !== lo; }) ? 'From ' : '') + money(lo);
    }
    // "Reflective +£10": the finish's extra over the default, as on the product page
    var base = finish ? minPrice(ofFinish(finish)) : 0;
    var labels = finishes.map(function (f) {
      var extra = minPrice(ofFinish(f)) - base;
      return extra > 0 ? f + ' +' + money(extra, true) : f;
    });

    var img = btn.closest('.card-wrapper') && btn.closest('.card-wrapper').querySelector('.card__media img');
    var addHtml = '';
    function refresh() {
      var sheet = document.querySelector('.rl-sheet');
      if (!sheet) return;
      sheet.querySelector('.rl-sheet__price').innerHTML = priceHtml();
      sheet.querySelectorAll('.rl-sheet__size').forEach(function (row) {
        var v = variant(row.querySelector('span').textContent);
        var add = row.querySelector('.rl-sheet__add');
        if (!addHtml && !row.disabled) addHtml = add.innerHTML;
        row.disabled = !(v && v.available);
        add.innerHTML = row.disabled ? 'Sold out' : (addHtml || 'Add to bag');
      });
    }

    bag.sheet({
      title: p.title.replace(' — Ready to Ship', '').replace(' — Last Sizes', ''),
      price: priceHtml(),
      image: img ? (img.currentSrc || img.src) : '',
      groups: finishes.length > 1 ? [{
        label: 'Print finish',
        values: labels,
        selected: labels[finishes.indexOf(finish)],
        onPick: function (label) { finish = finishes[labels.indexOf(label)]; refresh(); }
      }] : [],
      sizes: sizes.map(function (s) { var v = variant(s); return { label: s, disabled: !(v && v.available) }; }),
      onSize: function (size) {
        var v = variant(size);
        if (!v || !v.available) return false;
        return bag.add([{ id: v.id, quantity: 1 }]).then(function () {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.open === 'function' && !d.classList.contains('active')) d.open();
          return true;
        }, function (err) {
          if (bag.snack) bag.snack(err && err.message ? err.message : 'Could not add to bag');
          return false;
        });
      }
    });
    refresh();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rl-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var url = btn.getAttribute('data-rl-quick-add');
    var bag = window.RunItBagV2;
    // no bag script, or bag v2 switched off (PostHog kill switch): the product page instead
    if (!bag || !bag.sheet || !bag.add || document.documentElement.classList.contains('rl-off-bag-v2')) { location.href = url; return; }
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { open(p, btn, bag); })
      .catch(function () { location.href = url; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();
